import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useUserLoginEvent = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const handleUserLoginEvent = useCallback(
    async (email) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        // Log the user login event with WebEngage
        window.webengage.user.login(email);
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { handleUserLoginEvent };
};

export default useUserLoginEvent;
